var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBin5Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2423_53119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 6.6665H16.666V17.4998C16.666 17.7209 16.5782 17.9328 16.4219 18.0891C16.2657 18.2454 16.0537 18.3332 15.8327 18.3332H4.16602C3.945 18.3332 3.73304 18.2454 3.57676 18.0891C3.42048 17.9328 3.33268 17.7209 3.33268 17.4998V6.6665ZM4.99935 8.33317V16.6665H14.9993V8.33317H4.99935ZM7.49935 9.99984H9.16602V14.9998H7.49935V9.99984ZM10.8327 9.99984H12.4993V14.9998H10.8327V9.99984ZM5.83268 4.1665V2.49984C5.83268 2.27882 5.92048 2.06686 6.07676 1.91058C6.23304 1.7543 6.445 1.6665 6.66602 1.6665H13.3327C13.5537 1.6665 13.7657 1.7543 13.9219 1.91058C14.0782 2.06686 14.166 2.27882 14.166 2.49984V4.1665H18.3327V5.83317H1.66602V4.1665H5.83268ZM7.49935 3.33317V4.1665H12.4993V3.33317H7.49935Z",
    fill: "#C5292A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2423_53119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin5Line);
export default __webpack_public_path__ + "static/media/delete-bin-5-line.1f56ad0380f3ec6e29cc23adf733d1b9.svg";
export { ForwardRef as ReactComponent };